// @mui
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { translateKey } from 'src/locales/translate';


// ----------------------------------------------------------------------

type CancelVisitModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAccept: (reason?: string) => void;
  isLoading?: boolean;
};

export default function OrganizationCancelVisitModal({
  isOpen,
  onClose,
  onAccept,
  isLoading,
}: CancelVisitModalProps) {
  const [reason, setReason] = useState('');

  const handleAccept = () => {
    onAccept(reason || undefined);
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{translateKey("hardcoded.odwolujesz_wizyte")}</DialogTitle>

      <DialogContent sx={{ maxWidth: '400px', pt: '8px !important' }}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label={translateKey("visit.cancelReasonOptional")}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          inputProps={{ 'data-testid': 'cancel-reason' }}
          sx={{ mb: 2 }}
        />
        <Alert severity="info">{translateKey("hardcoded.wlasciciel_pupila_oraz_specjalista_zostana_poinformowani_o_odwolaniu")}</Alert>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={handleClose}>{translateKey("common.close")}</Button>
        <LoadingButton
          variant="contained"
          color="error"
          data-testid="cancel-visit-confirm"
          onClick={handleAccept}
          disabled={isLoading}
          loading={isLoading}
        >
          <span>{translateKey("visit.cancelVisitShort")}</span>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
